
import { defineComponent, PropType } from 'vue';
import GridRowCell from './GridRowCell.vue';
import GridRowData from '@/models/grid/GridRowData';
import GridRowCellData from '@/models/grid/GridRowCellData';

export default defineComponent({
    components: {
        GridRowCell
    },
    props: {
        rowData: {
            type: Object as PropType<GridRowData>,
            required: true
        }
    },
    computed: {
        cellDatas(): GridRowCellData[] {
            return this.rowData.cells;
        },
        photoRow(): boolean {
            return this.rowData.photoRow;
        }
    }
});
